/**
 * PROVISIONAL — USER TUNING REQUIRED.
 *
 * These constants only establish a deterministic, testable controller envelope.
 * They have not received the required user-led movement-feel pass. Do not treat
 * any value in this object as accepted tuning.
 */
export const MOVEMENT_TUNING = Object.freeze({
  walkSpeedMetresPerSecond: 3.8,
  sprintSpeedMetresPerSecond: 6.2,
  accelerationMetresPerSecondSquared: 18,
  decelerationMetresPerSecondSquared: 22,
  flightSpeedMetresPerSecond: 18,
  boostedFlightSpeedMetresPerSecond: 42,
  flightAccelerationMetresPerSecondSquared: 60,
  flightDecelerationMetresPerSecondSquared: 80,
  turnSpeedRadiansPerSecond: 12,
  gravityMetresPerSecondSquared: 22,
  jumpLaunchSpeedMetresPerSecond: 6.4,
  coyoteTimeSeconds: 0.1,
  jumpBufferTimeSeconds: 0.12,
  maximumStepHeightMetres: 0.34,
  maximumWalkableSlopeRadians: Math.PI * 0.25,
  mantleMaximumHeightMetres: 1.05,
  characterCapsuleRadiusMetres: 0.34,
  characterCapsuleHeightMetres: 1.84,
  landingResponseSeconds: 0.16,
  walkFootstepDistanceMetres: 1.55,
  sprintFootstepDistanceMetres: 1.82,
  minimumFootstepSpeedMetresPerSecond: 0.45,
});
